<template>
    <div class="my-45">
        <div class="container">
            <h1>404 - page not found</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Error404'
}
</script>